var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBellHigh(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3628_71722)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.9987 18.332C10.9154 18.332 11.6654 17.582 11.6654 16.6654H8.33203C8.33203 17.582 9.08203 18.332 9.9987 18.332ZM14.9987 13.332V9.16536C14.9987 6.60703 13.6404 4.46536 11.2487 3.8987V3.33203C11.2487 2.64036 10.6904 2.08203 9.9987 2.08203C9.30703 2.08203 8.7487 2.64036 8.7487 3.33203V3.8987C6.36536 4.46536 4.9987 6.5987 4.9987 9.16536V13.332L3.33203 14.9987V15.832H16.6654V14.9987L14.9987 13.332ZM13.332 14.1654H6.66536V9.16536C6.66536 7.0987 7.9237 5.41536 9.9987 5.41536C12.0737 5.41536 13.332 7.0987 13.332 9.16536V14.1654Z",
    fill: "#475467"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3628_71722"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellHigh);
export default __webpack_public_path__ + "static/media/bell-high.f32e26d84bd9cc55eaae95f07d16a66b.svg";
export { ForwardRef as ReactComponent };